var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMore)?_c('div',{staticClass:"show-more"},[_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.onShowMore($event)}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }